/* Two-tone section heading (page spec section 3): the lead in ink, the tail
   in gray on its own line, then at most one sub line. */
export default function SectionHead({ id, lead, tail, sub, align = 'center', className = '' }) {
  return (
    <div className={`cxs-head cxs-head-${align} ${className}`}>
      <h2 id={id} className="cxs-h2">
        <span>{lead}</span>
        {' '}
        <span className="cxs-h2-tail">{tail}</span>
      </h2>
      {sub ? <p className="cxs-sub">{sub}</p> : null}
    </div>
  );
}
